import { useEffect, useRef } from "react"
import * as L from "leaflet/src/Leaflet"

export default function LocationsMap({ devices }) {
  const containerRef = useRef(null)

  useEffect(() => {
    if (!containerRef.current || devices.length === 0) return

    const map = L.map(containerRef.current)

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      referrerPolicy: "origin-when-cross-origin",
      subdomains: ["a", "b", "c"],
    }).addTo(map)

    devices.forEach((device) => {
      L.circleMarker([device.latitude, device.longitude], {
        color: "black",
        fill: true,
        fillColor: "#f75448",
        fillOpacity: 1,
        radius: 5,
        weight: 1,
      })
        .on("click", () => {
          window.location = device.url
        })
        .bindTooltip(device.name)
        .addTo(map)
    })

    const latlngs = devices.map((d) => [d.latitude, d.longitude])
    const path = L.polyline(latlngs)

    const timeoutId = setTimeout(() => {
      map.invalidateSize(true)
      map.fitBounds(path.getBounds())
    }, 100)

    return () => {
      clearTimeout(timeoutId)
      map.remove()
    }
  }, [devices])

  if (devices.length === 0) return null

  return <div ref={containerRef} id="map-canvas" />
}
